import * as moment from 'moment';

export class ZohoToken {
  access_token: string;
  refresh_token: string;
  expires_in_sec: number;
  api_domain: string;
  token_type: string;
  expires_in: number;
  expiryDt: Date;


  public get expired(){
    if (moment(this.expiryDt).isBefore(moment())){
      // console.log('Expired!');
      return true;
    }
    // console.log('Not Expired!');
    return false;
  }

}
